var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectCardDownBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 13,
    viewBox: "0 0 374 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4.5 5L368.5 4.87688L374 0V9H0V0Z",
    fill: "#A8CED0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H110",
    stroke: "#A8CED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCardDownBorder);
export default __webpack_public_path__ + "static/media/ProjectCardDownBorder.a4f90455c965d34013069e732fa4069a.svg";
export { ForwardRef as ReactComponent };